import React from 'react'
import { View } from 'react-native'
import { api } from '@ppwr/convex/_generated/api'
import { useQuery } from 'convex/react'

import { DS } from '@/design-system'
import { numberWithCommas } from '@/utils/numberWithCommas'

import Diamond from '@/assets/diamonds/Diamond.svg'

export function DiamondsBalance() {
  const diamonds = useQuery(api.diamonds.queries.getMyDiamonds)
  const balance = numberWithCommas(diamonds?.balance || 0)
  const lifetimeEarned = numberWithCommas(diamonds?.lifetimeEarned || 0)

  return (
    <View style={{ flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-around', alignItems: 'flex-start', rowGap: DS.spacing[12] }}>
      <DiamondsBalanceItem value={balance} label="Available Balance" />
      <View style={{ width: 1, alignSelf: 'stretch', backgroundColor: DS.palette['Brand/Light Grey'] }} />
      <DiamondsBalanceItem value={lifetimeEarned} label="Lifetime Earned" />
    </View>
  )
}

interface DiamondsBalanceItemProps {
  value: string
  label: string
}

const DiamondsBalanceItem = ({ value, label }: DiamondsBalanceItemProps) => (
  <View style={{ flex: 1, alignItems: 'center', gap: DS.spacing[4] }}>
    <View style={{ flexDirection: 'row', gap: 4, alignItems: 'center' }}>
      <Diamond width={24} height={24} />
      <DS.Text style={{ top: 1.5 }} variant="Heading 3/Medium">{value}</DS.Text>
    </View>
    <DS.Text variant="Caption/Medium">{label}</DS.Text>
  </View>
)
